import React from "react";
import { Check, Phone, MessageCircle, Compass } from "lucide-react";

const TOPICS = [
  "Best time to visit Munnar",
  "How to travel to Munnar",
  "Key things to consider before your trip",
  "Age-appropriate activities for your group",
  "Ideal number of days to spend",
  "Making your Munnar trip cost-effective",
  "Managing your diet for maximum enjoyment",
  "Beyond tea gardens - hidden gems of Munnar",
  "Availability of essentials in and around Munnar",
  "What to wear for Munnar's climate",
  "Safety aspects for travellers",
  "Languages spoken and usable in Munnar",
  "Currency, cards and UPI payments",
  "Banks and ATMs available in Munnar",
  "Drinking water availability",
  "Eco-friendly rules in the Ghat region",
  "Entry timings and restrictions",
  "Unbiased where-to-stay tips",
  "Advice for travellers with allergies",
  "Any other Munnar travel question",
];

const TravelConsultancy = () => (
  <section id="consultancy" className="py-20 md:py-28 bg-neutral-50">
    <div className="max-w-7xl mx-auto px-5 md:px-8">
      <div className="text-center mb-14">
        <p className="text-xs font-semibold tracking-[0.25em] uppercase text-[#17a89b] mb-4">
          Complimentary Travel Consultancy
        </p>
        <h2 className="text-3xl md:text-5xl font-extrabold text-neutral-900 mb-4">
          Plan Your Perfect Munnar Journey — Free of Charge
        </h2>
        <p className="text-neutral-600 max-w-3xl mx-auto leading-8">
          Munnar is far more than misty hills and tea gardens — it is a living tapestry of
          wilderness, culture, adventure, and flavour waiting to be discovered. Before you set out,
          let our resident expert guide you through every detail of your trip, completely free of
          cost.
        </p>
      </div>

      <div className="grid lg:grid-cols-3 gap-8 items-start">
        {/* Topics checklist */}
        <div className="lg:col-span-2 bg-white rounded-3xl p-8 md:p-10 shadow-sm">
          <div className="grid sm:grid-cols-2 gap-x-8 gap-y-4">
            {TOPICS.map((t) => (
              <div key={t} className="flex items-start gap-3">
                <span className="w-6 h-6 shrink-0 rounded-full bg-[#e3faf7] flex items-center justify-center mt-0.5">
                  <Check className="w-3.5 h-3.5 text-[#17a89b]" />
                </span>
                <span className="text-neutral-700 text-sm leading-6">{t}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Expert card */}
        <div className="bg-[#0f2e2b] rounded-3xl p-8 md:p-10 text-center">
          <div className="w-16 h-16 rounded-2xl bg-[#17a89b]/20 flex items-center justify-center mx-auto mb-5">
            <Compass className="w-8 h-8 text-[#25d3c4]" />
          </div>
          <h3 className="text-2xl font-bold text-white mb-1">Savio Amantius</h3>
          <p className="text-[#25d3c4] text-sm font-medium mb-1">
            Resident Travel Expert &amp; Engineer
          </p>
          <p className="text-neutral-400 text-xs mb-6">Speaks English &amp; Malayalam</p>

          <p className="text-neutral-300 italic leading-7 text-sm mb-8">
            "Whether you are a first-time visitor or a seasoned traveller returning to Munnar, I am
            here to make your journey smoother, richer, and truly unforgettable — at absolutely no
            charge."
          </p>

          <div className="flex flex-col gap-3">
            <a
              href="tel:+919388881016"
              className="inline-flex items-center justify-center gap-2 bg-[#25d3c4] hover:bg-[#1cc0b2] text-[#0f2e2b] font-semibold px-6 py-3 rounded-lg transition-colors"
            >
              <Phone className="w-4 h-4" /> Call Savio Now
            </a>
            <a
              href="https://wa.me/919388881016"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 border border-white/30 hover:bg-white/10 text-white font-semibold px-6 py-3 rounded-lg transition-colors"
            >
              <MessageCircle className="w-4 h-4" /> WhatsApp Savio
            </a>
          </div>

          <p className="text-neutral-400 text-xs mt-5">
            100% free. No booking obligation whatsoever.
          </p>
        </div>
      </div>
    </div>
  </section>
);

export default TravelConsultancy;
